import { FormControlLabel, Stack, Typography } from '@mui/material';
import { GenerateReport } from '../GenerateReport';
import { ComponentCardListSkeleton } from './ComponentCard';
import { ComponentDetails } from './ComponentDetails';
import { ComponentsList } from './ComponentsList';
import { useComponentsTabData } from './hooks/useComponentsTabData';
import { Container, Footer, Header, StyledCheckbox } from './styles';
import { CustomSkeleton } from './ComponentCard/styles';
import { LocationTag } from '../../../../constants';

const ComponentsTabSkeleton = () => {
  return (
    <Container>
      <Header>
        <CustomSkeleton variant="rectangular" animation="wave" width="1.8rem" height="1.8rem" />
        <CustomSkeleton variant="text" animation="wave" width="7rem" height="1.6rem" />
      </Header>
      <ComponentCardListSkeleton />
      <Footer>
        <CustomSkeleton
          variant="rectangular"
          animation="wave"
          height="4.4rem"
          sx={{ borderRadius: '0.4rem' }}
        />
      </Footer>
    </Container>
  );
};

export const ComponentsTab = ({ changeTab }: { changeTab: (selectedTabIndex: number) => void }) => {
  const {
    currentComponents,
    componentCount,
    selectedComponentId,
    allComponentsSelected,
    initialLoading,
    handleSelectAllComponentsChange,
    loadMore,
  } = useComponentsTabData();

  return (
    <Container>
      {selectedComponentId && <ComponentDetails changeTab={changeTab} />}
      {!selectedComponentId && (
        <>
          {initialLoading ? (
            <ComponentsTabSkeleton />
          ) : (
            <>
              <Header>
                <FormControlLabel
                  sx={{ margin: 0 }}
                  control={
                    <StyledCheckbox
                      disableRipple
                      checked={allComponentsSelected}
                      onChange={handleSelectAllComponentsChange}
                    />
                  }
                  label={
                    <Stack direction="row" alignItems="center" gap="0.4rem">
                      <Typography variant="h6" lineHeight="normal" color="primary.500">
                        {componentCount}
                      </Typography>
                      <Typography
                        variant="h6"
                        lineHeight="normal"
                        fontWeight={400}
                        color="primary.400"
                      >
                        total components
                      </Typography>
                    </Stack>
                  }
                />
              </Header>
              <ComponentsList
                components={currentComponents}
                totalComponents={componentCount}
                loadMore={loadMore}
              />
              <Footer>
                <GenerateReport variant="lg" location={LocationTag.ViewerComponents} />
              </Footer>
            </>
          )}
        </>
      )}
    </Container>
  );
};
